import { render, staticRenderFns } from "./CaseNoteDrawer.vue?vue&type=template&id=c0bcfe10&scoped=true&"
import script from "./CaseNoteDrawer.vue?vue&type=script&lang=ts&"
export * from "./CaseNoteDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CaseNoteDrawer.vue?vue&type=style&index=0&id=c0bcfe10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bcfe10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
